import {
  FC,
  PropsWithChildren,
  createContext,
  memo,
  useContext,
  useState,
} from 'react';
import { SelectedValue, SetSelectedValue } from './type';

export const createValueProvider = <T,>() => {
  const valueContext = createContext<SelectedValue<T> | undefined>(undefined);
  const setValueContext = createContext<SetSelectedValue<T>>(() => {});

  const SelectedValueProvider: FC<PropsWithChildren> = memo(({ children }) => {
    const [selectedValue, setSelectedValue] = useState<
      SelectedValue<T> | undefined
    >(undefined);
    return (
      <setValueContext.Provider value={setSelectedValue}>
        <valueContext.Provider value={selectedValue}>
          {children}
        </valueContext.Provider>
      </setValueContext.Provider>
    );
  });
  SelectedValueProvider.displayName = 'SelectedValueProvider';

  const useSelectedValue = () => useContext(valueContext);
  const useSetSelectedValue = () => useContext(setValueContext);

  return {
    SelectedValueProvider,
    useSelectedValue,
    useSetSelectedValue,
  };
};
